import { render, staticRenderFns } from "./OrderDeta.vue?vue&type=template&id=079862b2&scoped=true"
import script from "./OrderDeta.vue?vue&type=script&lang=js"
export * from "./OrderDeta.vue?vue&type=script&lang=js"
import style0 from "./OrderDeta.vue?vue&type=style&index=0&id=079862b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079862b2",
  null
  
)

export default component.exports